<script lang="ts">
    import { tick } from "svelte"

    let buttons: HTMLDivElement
    let width: number

    let fullwidth = false

    $: if (buttons && width) requestAnimationFrame(() => determineFullwidth())
    async function determineFullwidth() {
        // Reset fullwidth
        fullwidth = false

        await tick()
        // Get items
        const items = Array.from(buttons.children)
            .flatMap((e) => (e instanceof HTMLElement && e.tagName !== "IFRAME" ? [e] : []))
            .map((e) => e.offsetWidth)

        // Get width of all items, and gap
        const gap = (items.length - 1) * parseFloat(getComputedStyle(buttons).gap)
        const widths = items.reduce((total, current) => total + current, 0)

        const totalItemsWidth = gap + widths
        const collapsed = width <= totalItemsWidth

        fullwidth = collapsed
    }
</script>

<div class="popup-buttons-shell">
    <div
        bind:this={buttons}
        bind:clientWidth={width}
        class:fullwidth
        class="popup-buttons flex justify-center gap-4 flex-wrap"
    >
        <slot />
    </div>
</div>

<style>
    .popup-buttons-shell {
        margin: 1rem -1rem -1rem;
        border-top: 1px solid var(--color-purple-100);
        border-radius: 0 0 1rem 1rem;
        background: var(--color-purple-50);
        padding: 1rem;
    }

    .popup-buttons.fullwidth {
        flex-direction: column-reverse;
    }

    .popup-buttons.fullwidth > :global(*) {
        width: 100%;
    }

    :global(.darkmode) .popup-buttons-shell {
        border-top-color: var(--color-grey-700);
        background: var(--color-grey-800);
    }
</style>
